import isEmpty from 'lodash.isempty';
import PropTypes from 'prop-types';
import { useEffect, useRef, useState } from 'react';
import CONSTANTS from '../../../constants';

const CloseRequestModal = ({
	isOpen = false,
	closeStatus = '',
	onClose,
	onCancel,
}) => {
	const modalRef = useRef();
	const [closedReason, setClosedReason] = useState('');
	useEffect(() => {
		if (isOpen) {
			modalRef.current.showModal();
		}
	}, [isOpen]);

	const handleCloseClick = () => {
		onClose(closedReason);
	};

	return (
		<dialog id="close-request-dialog" className="modal" ref={modalRef}>
			<div className="modal-box">
				<h3>{CONSTANTS.shortStatus[closeStatus]} Service Request?</h3>
				<div className="py-4">Are you sure?</div>
				{closeStatus === 'closed' && (
					<div className="form-control">
						<label className="cursor-pointer label">
							Reason service not provided
						</label>
						<select
							className="w-full max-w-xs select select-bordered"
							onChange={(e) => setClosedReason(e.target.value)}
							value={closedReason}
						>
							<option value="" disabled>
								Select reason
							</option>
							<option value="closed-no-contact">
								Unable to Contact Client
							</option>
							<option value="closed-duplicate">
								Duplicate Service Request (referral was a duplicate)
							</option>
							<option value="closed-service-not-available">
								Service not currently available
							</option>
							<option value="closed-registration">
								Registration full/past deadline
							</option>
							<option value="closed-ineligible">
								Client ineligible (income, lack of documentation, previously
								assisted, other)
							</option>
							<option value="closed-service-inaccessible">
								Service inaccessible (hours, cost, disability, other)
							</option>
							<option value="closed-opted-out">Client opted out</option>
							<option value="closed-other">Other</option>
						</select>
					</div>
				)}
				<div className="modal-action">
					<form method="dialog">
						<button className="btn" onClick={onCancel}>
							No
						</button>
						<button
							className="ml-4 btn btn-primary"
							onClick={handleCloseClick}
							disabled={closeStatus === 'closed' && isEmpty(closedReason)}
						>
							Yes
						</button>
					</form>
				</div>
			</div>
		</dialog>
	);
};

CloseRequestModal.propTypes = {
	isOpen: PropTypes.bool,
	closeStatus: PropTypes.string,
	onClose: PropTypes.func.isRequired,
	onCancel: PropTypes.func.isRequired,
};

export default CloseRequestModal;
